module.exports = __webpack_public_path__ + "components/footer/federation-of-drama-schools-logo.png";